







import { Component, Prop, Vue } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import JsonEditor from '@/components/JsonEditor.vue';
import axios from 'axios';

@Component({
    components: { JsonEditor, FormFooter },
})
export default class FarmVehicleTypeMapBackground extends Vue {
    @Prop({ type: Number, required: true })
    vehicleTypeId!: number;

    @Prop({ type: Number, required: true })
    farmId!: number;

    background = '';

    async mounted(): Promise<void> {
        try {
            const { data } = await axios.get(this.url, {
                responseType: 'blob',
                silentErrorStatuses: [404],
            });
            this.background = URL.createObjectURL(data);
        } catch (e) {
            this.background = '';
        }
    }

    async submit(): Promise<void> {
        this.$emit('submitted');
    }

    get url(): string {
        return `${process.env.VUE_APP_ALARMCENTER_API_URL}/web/farms/${this.farmId}/map/${this.vehicleTypeId}/background`;
    }
}

